export default [
	{
		name: 'New Product',
		badge_type: 'new_product'
	},
	{
		name: 'Updated',
		badge_type: 'updated'
	},
	{
		name: 'Sneak Peek',
		badge_type: 'sneak_peek'
	},
	{
		name: 'Discontinued',
		badge_type: 'discontinued'
	}
]